import React, {useEffect, useState} from 'react';
import styled, {ThemeProvider} from "styled-components";
import {Dark, Light} from "./app/theme";
import {Router} from "./features/Router/Router";
import {Alert} from "./features/Alert/Alert";
import {BrowserRouter} from "react-router-dom";
import {LocalStorageEnum} from "./enum/localStorage";
import {Provider} from "inversify-react";
import {container} from "./app/diContainer";
import {useAppDispatch, useAppSelector} from "./app/hooks";
import {AuthorizationByToken, resetState} from "./features/Auth/slice";
import {LoaderEnum, MiniLoader} from "./ui/Loader/MiniLoader";
import {LanguageEnum} from "./enum/language";
import {useTranslation} from "react-i18next";
import {Popup} from "./ui/Modal/Popup";
import {ModalActiveBtn} from "./components/ui/Button";
import {resetRegister} from "./utils/resetRegister";

export enum ThemeEnum {
    dark = 'dark',
    light = 'light'
}

const urlSearch = new URLSearchParams(window.location.search)
const client_id = urlSearch.get('client_id')
const redirect_uri = urlSearch.get('redirect_uri')
const response_type = urlSearch.get('response_type')
const state = urlSearch.get('state')

const preventRedirect: boolean = (
    !!client_id
    && !!redirect_uri
    && !!response_type
)

export const App = () => {

    const dispatch = useAppDispatch()
    const {i18n, t} = useTranslation();
    const [theme, setTheme] = useState(Light)
    const {token, isAuthFetching, needPasswordReset} = useAppSelector(state => state.auth)

    useEffect(() => {
        if (token && redirect_uri && response_type && client_id) {
            dispatch(AuthorizationByToken({
                client_id: client_id,
                redirect_uri: redirect_uri,
                response_type: response_type,
                state: state,
            }))
        }

        if (localStorage.getItem(LocalStorageEnum.theme)) {
            if (localStorage.getItem(LocalStorageEnum.theme) === ThemeEnum.dark) {
                setTheme(Dark)
            }
        } else {
            localStorage.setItem(LocalStorageEnum.theme, ThemeEnum.light)
        }

        const lang = localStorage.getItem(LocalStorageEnum.lang)

        switch (lang) {
            case (LanguageEnum.Ru) : {
                i18n.changeLanguage(LanguageEnum.Ru)
                return
            }
            case (LanguageEnum.En) : {
                i18n.changeLanguage(LanguageEnum.En)
                return
            }
            default : {
                localStorage.setItem(LocalStorageEnum.lang, LanguageEnum.Ru)
                return;
            }
        }
    }, [])

    return <div>
        <Provider container={container}>
            <ThemeProvider theme={theme}>
                {isAuthFetching && (preventRedirect && token) ? <AuthFetchingContainer>
                        <MiniLoader color={theme.color.indicator} size={LoaderEnum.medium}/>
                    </AuthFetchingContainer> :
                    <>
                        <BrowserRouter>
                            <Router preventRedirect={preventRedirect}/>
                        </BrowserRouter>
                        <Alert/>

                        <Popup
                            style={{width: 'fit-content', height: 'fit-content'}}
                            opened={needPasswordReset}
                            title={t('auth.needResetPassword')}>
                            <ModalActiveBtn style={{margin: '0 auto'}} onClick={() => {
                                dispatch(resetState())
                                resetRegister()
                                window.location.replace('/password/recovery')
                            }}>
                                OK
                            </ModalActiveBtn>
                        </Popup>
                    </>}
            </ThemeProvider>
        </Provider>
    </div>
}

const AuthFetchingContainer = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
`
